export const Mutations = Object.freeze({
  SET_APP_ID: "setAppId",
  SHOW_APPS_MODAL: "showAppsModal",
  SET_PANORAMA_ERROR: "setPanoramaError",
  //Me
  SET_FORM: "resetForm",
  SET_USER: "setUser",
  SET_LOGIN_STATUS: "setLoginStatus",
  SET_SESSION_DATA: "setSessionData",

  //Hotspots
  SET_HOTSPOTS: "setHotspots",
  SET_HOTSPOT: "setHotspot",
  SET_HOTSPOT_POIS: "setHotspotPois",
  SET_HOTSPOT_LAYER: "setHotspotLayer",

  //Articles
  SET_ARTICLE: "selectArticle",
  ADD_ARTICLE_STACK: "addArticleStack",
  REMOVE_ARTICLE_STACK: "removeArticleStack",
  CLEAR_ARTICLE_STACK: "clearArticleStack",
  TOGGLE_ARTICLE_DRAWER: "toggleArticleDrawer",

  //Menu
  TOGGLE_MENU: "toggleMenu",
  TOGGLE_SIDEBAR_MENU: "toggleSidebarMenu",
  RESET_SIDEBAR_MENU: "resetSidebarMenu",

  SET_LOCALE: "setLocale",

  //THEMES
  SET_THEMES: "setThemes",
  SET_SELECTED_THEME: "setSelectedTheme",
  RESET_THEME: "resetTheme",
  RESET_THEMES: "resetThemes",

  //ROUTES
  SET_ROUTES: "setRoutes",
  SET_SELECTED_ROUTE: "setSelectedRoute",
  RESET_ROUTE: "resetRoute",
  RESET_ROUTES: "resetRoutes",

  //SEARCH
  SET_5D_SEARCH: "set5DSearch",
  REMOVE_5D_SEARCH: "remove5DSearch",

  TOGGLE_MENU_DRAWER: "toggleMenuDrawer",

  //TIMELAYERS
  SET_TIMELAYER: "setTimelayer",
  SET_TIMELAYERS: "setTimeLayers",

  //FEATURED ARTICLES
  SET_FEATURED_ARTICLES: "setFeaturedArticles",
  SHOW_FEATURED_ARTICLES: "showFeaturedArticles"
});

export const Actions = Object.freeze({
  //Me
  LOGIN_USER: "loginUser",
  LOGOUT_USER: "logoutUser",

  //Hotspots
  GET_HOTSPOTS: "getHotspots",
  GET_HOTSPOT: "getHotspot",

  //POIS
  GET_POIS: "getPois",
  GET_POI: "getPoi",

  //THEMES
  GET_THEMES: "getThemes",
  SELECT_THEME: "selectTheme",

  //ROUTES
  GET_ROUTES: "getRoutes",
  SELECT_ROUTE: "selectRoute",

  //SEARCH
  GET_5D_SEARCH: "get5DSearch",

  //ARTICLE
  GET_ARTICLE: "getArticle",
  ADD_ARTICLE: "addArticle",

  //COMMENTS
  ADD_COMMENT: "addComment",

  //FEATURED ARTICLES
  GET_FEATURED_ARTICLES: "getFeaturedArticles"
});
